import type { Condition } from './enums';

/**
 * Marker colours by last condition: the same on the phone map, the web map and
 * the legend, so a student and a board member read the same picture.
 * green H, amber S, grey D, hollow NF (stroke only), blue = you.
 */
export const CONDITION_COLORS: Record<Condition, { fill: string; stroke: string; hollow: boolean }> = {
  H: { fill: '#2e7d32', stroke: '#1b5e20', hollow: false },
  S: { fill: '#f9a825', stroke: '#c17900', hollow: false },
  D: { fill: '#757575', stroke: '#424242', hollow: false },
  NF: { fill: '#ffffff', stroke: '#9e9e9e', hollow: true },
};

/** A tree with no measurement yet. */
export const UNMEASURED_COLOR = { fill: '#90caf9', stroke: '#1565c0', hollow: false } as const;

export const DEVICE_COLOR = { fill: '#1e88e5', stroke: '#ffffff', ring: 'rgba(30,136,229,0.18)' } as const;

export const BRAND = {
  /** Deep forest green: headers, primary buttons. */
  primary: '#1b5e20',
  /** Lighter leaf green: accents. */
  accent: '#66bb6a',
  /** Paper: the worksheet colour, backgrounds. */
  paper: '#fbfaf5',
  ink: '#1f2a1f',
} as const;
